import $ from "jquery";
import { contentMeta, createNanoId, isMobile } from "#scripts/general_functions";
import language from "#scripts/translation";
import { getLangForApi } from "#scripts/cmsapi.js";
import { getImageByContentId } from "#scripts/images";
import breadcrumb from "#templates/pages/breadcrumb";

export const setNews = (news) => {
	let newsList = [];

	$.each(news.listOfContent, (a, b) => {
		const date = new Date(b.published ?? b.modified);

		const pDate = `${`0${date.getDate()}`.slice(-2)}.${`0${date.getMonth() + 1}`.slice(-2)}.${date.getFullYear()}`;

		newsList.push(`
                <div class="newslist__item__frontpage">
                    <h2 class="newslist__header">
                        <a href="/news/${b.contentId}" class="newslist__link"><span>${b.title}</span></a>
                    </h2>
                    <p class="newslist__intro">${b.intro}</p>
                    <div class="newslist__date text-right">${pDate}</div>
                </div>`);
	});

	newsList = newsList.join("");

	return newsList;
};

export const getNews = (category, num, from, callback) => {
	const clientid = window.serverdata.configMeta.aim.clientId;
	const categoryFilter = category ? `&category=${category}` : "";
	const apiCall = `${window.apiUrl}/Public/articles`;
	const apiParameters = `?subscriptionId=${clientid}&contentType=73da834a-d2cf-4659-ab23-760986ecbfde${categoryFilter}&language=${getLangForApi()}&includeCategories=true&offset=${from}&limit=${num}&sortBy=Published&useSortIndex=true&getRecursiveContent=true`;

	fetch(apiCall + apiParameters)
		.then((results) => results.json())
		.then((data) => {
			callback(data);
		});
};

// export const getNewsRss = (num = 3, from = 0) => {
// 	const clientid = window.serverdata.configMeta.aim.clientId;

// 	fetch(`${window.apiUrl}/PublicContentApi/getcontentlistdescendingrss/${clientid}/mal_nyhet/${num}/${from}/Published`)
// 		.then((response) => response.text())
// 		.then((data) => {
// 			document.open();
// 			document.write(data);
// 			document.close();
// 		});
// };

export const getArticles = (category, num, from, callback) => {
	const clientId = window.serverdata.configMeta.aim.clientId;

	const apiCall = `${window.apiUrl}/Public/articles`;
	const apiParameters = `?subscriptionId=${clientId}&category=${category}&language=${getLangForApi()}&limit=${num}&offset=${from}&getRecursiveContent=true&LanguageMode=Strict`;

	fetch(apiCall + apiParameters)
		.then((results) => results.json())
		.then((data) => {
			callback(data);
		});
};

export const setFrontNews = (num = 3) => {
	getNews(null, num, 0, (result) => {
		const news = setNews(result);

		$("#news").html(news);

		if (result.totalCount > num) {
			$("#news").append(`
            <div class="news__summary text-right">
                <a href="/liste/nyheter" class="newslist__seeall">${language("NEWS_SEEALL")}</a>
            </div>
            `);
		}
	});
};

export const setNewsList = (_from, _loadNum) => {
	document.title = language("NEWS_NEWS");
	const breadcrumbHtml = breadcrumb();
	const loadNum = _loadNum || 10;
	const from = _from || 0;

	// if (/rss=1/.exec(location.search.toLowerCase())) {
	// 	getNewsRss(loadNum, from);
	// }

	getNews(null, loadNum, from, (resultUnsorted) => {
		const availablenews = resultUnsorted.totalCount;
		let newsList = [];

		const result = resultUnsorted.listOfContent.sort((a, b) => {
			const aDate = a.published ?? a.modified;
			const bDate = b.published ?? b.modified;
			if (aDate < bDate) return 1;
			if (aDate > bDate) return -1;
			return 0;
		});

		result.forEach((item, index) => {
			if (index === Number.parseInt(loadNum)) {
				return;
			}
			const date = new Date(item.published ?? item.modified);
			const pDate = `${`0${date.getDate()}`.slice(-2)}.${`0${date.getMonth() + 1}`.slice(-2)}.${date.getFullYear()}`;
			const meta = contentMeta(item);
			let img = "";
			let width = "col-sm-10";

			if (meta.imageContentId !== undefined && meta.imageContentId.length > 0) {
				const imgId = createNanoId();
				width = "col-sm-8";
				if (item.imagePath) {
					const url = item.imagePath.includes("preview.sdl.no") ? item.imagePath.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`) : item.imagePath;
					img = `<div class="col-sm-4 image__container">
										<img src="//res.cloudinary.com/ssp/image/fetch/c_fill,w_283,ar_16:9,g_auto:subject/c_limit,w_300/${url}" class="article__introimage" id="${imgId}" loading="lazy">
								</div>`;
				} else {
					img = `<div class="col-sm-4 image__container">
										<img src="/images/transparent.png" class="article__introimage" id="${imgId}" loading="lazy">
								</div>`;
					getImageByContentId(meta.imageContentId, (img) => {
						if (img.url !== undefined && img.url.length > 0) {
							if (img.url.includes("preview.sdl.no")) {
								img.url = img.url.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`);
							}
							$(`#${imgId}`).attr("src", `//res.cloudinary.com/ssp/image/fetch/c_fill,w_283,ar_16:9,g_auto:subject/c_limit,w_300/${img.url}`);
						}
						$(`#${imgId}`).attr("alt", img.alt);
					});
				}
			}

			newsList.push(`
                <div class="newslist__item">
                <a href="/nyhet/${item.contentId}" >
                    <div class="row">
                        ${img}
                        <div class="${width}">
                            <div class="newslist__content">
                                <h2 class="newslist__header" class="newslist__link">
                                    ${item.title}
                                </h2>
                                <p class="newslist__intro">${item.intro}</p>
                                <div class="newslist__date">${pDate}</div>
                            </div>
                        </div>
                    </div>
                    </a>
                </div>`);
		});

		$("#currentPageBreadcrumb").text(language("NEWS_NEWS"));
		newsList = newsList.join("");

		$(".newslist__list").append(newsList);

		if (availablenews > loadNum) {
			const pages = Math.ceil(availablenews / loadNum);
			const pageslinks = createPaging(pages, loadNum, from);
			const newslistFooter = `
            <div class="row">
                <div class="col mt-5">
                    <nav aria-label="${language("NEWS_BROWSEPAGES")}">
                      <ul class="pagination pagination-lg">
                        ${pageslinks}
                      </ul>
                    </nav>
                </div>
            </div>
            `;

			$(".newslist__footer").html(newslistFooter);
		}
	});

	$("body").off("click", ".news__page__links");

	$("body").on("click", ".news__page__links", function (e) {
		e.preventDefault();
		const num = $(this).data("from");
		setNewsList(Number.parseInt(num));
		window.scrollTo(0, 0);
	});

	const rssFeedLink = !window.serverdata.configMeta.aim?.rss?.enabled
		? ""
		: `<a href="${document.location.href}/rss" class="page__header__rss" title="RSS feed"><span class="material-icons-outlined notranslate header__icon">rss_feed</span></a>`;
	$("#maincontent").html(`
        <div class="container p-md-0">
            ${breadcrumbHtml}
        </div>
        <div class="container p-md-0">
            <div class="row justify-content-md-center">
                <div class="newslist col-md-10">

                    <h1 class="page__header">${language("NEWS_NEWS")}${rssFeedLink}</h1>
                    <div class="newslist__info"></div>
                    <div class="newslist__list"></div>
                    <div class="newslist__footer"></div>
                
                </div>
            </div>
        </div>
    `);
};

export const setArticleList = (cat, _from, _loadNum) => {
	const breadcrumbHtml = breadcrumb();
	const loadNum = _loadNum || 10;
	const from = _from || 0;
	const categories = JSON.parse(sessionStorage.getItem("aim-categories"));
	const categoryTitle = findCategoryTitle(categories, cat);

	getArticles(cat, loadNum, from, (result) => {
		const availablearticle = result.totalCount;
		let articleList = [];

		$.each(result.listOfContent, (a, b) => {
			const date = new Date(b.published ?? b.modified);

			const pDate = `${`0${date.getDate()}`.slice(-2)}.${`0${date.getMonth() + 1}`.slice(-2)}.${date.getFullYear()}`;
			const meta = contentMeta(b);
			let img = "";
			let width = "col-sm-10";

			if (b.title && !b.isVisibleInNavigation === false) {
				if (meta.imageContentId !== undefined && meta.imageContentId.length > 0) {
					const imgId = createNanoId();
					width = "col-sm-8";
					img = `
                      <div class="col-sm-4 image__container">
                          <img src="" alt="" class="news__introimage" id="${imgId}" loading="lazy" \>
                      </div>`;

					getImageByContentId(meta.imageContentId, (img) => {
						if (img.url !== undefined && img.url.length > 0) {
							$(`#${imgId}`).attr("src", img.url);
						}
					});
				}

				articleList.push(`
                  <div class="newslist__item">
                  <a href="/article/${b.contentId}" >
                      <div class="row">
                          ${img}
                          <div class="${width}">
                              <div class="newslist__content">
                                  <h3 class="newslist__header" class="newslist__link">
                                      <!--a href="/article/${b.contentId}" class="newslist__link"-->${b.title}<!--/a-->
                                  </h3>
                                  <p class="newslist__intro">${b.intro}</p>
                                  <div class="newslist__date">${pDate}</div>
                              </div>
                          </div>
                      </div>
                      </a>
                  </div>`);
			}
		});

		$("#currentPageBreadcrumb").text(document.title);
		articleList = articleList.join("");

		$(".newslist__list").append(articleList);

		if (availablearticle > loadNum) {
			const pages = Math.ceil(availablearticle / loadNum);
			const pageslinks = createPaging(pages, loadNum, from);
			const articlelistFooter = `
            <div class="row">
                <div class="col mt-5">
                    <nav aria-label="${language("NEWS_BROWSEPAGES")}">
                      <ul class="pagination  pagination-lg">
                        ${pageslinks}
                      </ul>
                    </nav>
                </div>
            </div>
            `;

			$(".newslist__footer").html(articlelistFooter);
		}
	});

	$("body").off("click", ".news__page__links");

	$("body").on("click", ".news__page__links", function (e) {
		e.preventDefault();
		const num = $(this).data("from");
		setArticleList(cat, Number.parseInt(num));
	});

	$("#maincontent").html(`
        <div class="container p-md-0">
            ${breadcrumbHtml}
        </div>
        <div class="container p-md-0">
            <div class="row justify-content-md-center">
                <div class="newslist col-md-10">

                    <h1 class="page__header">${categoryTitle}<a href="${document.location.href}/rss" class="page__header__rss" title="RSS feed"><span class="material-icons-outlined notranslate header__icon">rss_feed</span></a></h1>
                    <div class="newslist__info"></div>
                    <div class="newslist__list"></div>
                    <div class="newslist__footer"></div>
                
                </div>
            </div>
        </div>
    `);
};

const findCategoryTitle = (categories, findItem) => {
	let returnValue = null;
	$.each(categories, (index, cat) => {
		console.log(`${cat.previewItem}: ${cat.categoryId === findItem} (${cat.categoryId} === ${findItem})`);
		if (cat.categoryId === findItem) {
			returnValue = cat.previewItem;
			return cat.item;
		}

		// Item not returned yet. Search its children by recursive call.
		if (cat.children) {
			const subresult = findCategoryTitle(cat.children, findItem);

			// If the item was found in the subchildren, return it.
			if (subresult) {
				returnValue = subresult;
				return subresult;
			}
		}
	});
	// Nothing found? return null.
	return returnValue;
};

export const createPaging = (pages, loadNum, from) => {
	let pageslinks = [];

	const itemsBefore = isMobile() ? 1 : 4;
	const itemsAfter = isMobile() ? 2 : 4;
	const unspitNumber = isMobile() ? 5 : 15;
	for (let i = 0; i < pages; i++) {
		if (pages > unspitNumber) {
			if (isMobile()) {
				if (i === from / loadNum - itemsBefore) {
					pageslinks.push(
						'<li class="page-item"><a class="page-link news__page__links news__page__first" href="#" data-from="0" ><span class="material-icons-outlined notranslate">first_page</span></a></li>',
					);
				}
				if ((i <= from / loadNum && i >= from / loadNum - itemsBefore) || (i > from / loadNum && i <= from / loadNum + itemsAfter)) {
					pageslinks.push(
						`<li class="page-item ${i * loadNum === from ? "disabled" : ""}"><a class="page-link news__page__links " href="#" data-from="${i * loadNum}" >${i + 1}</a></li>`,
					);
				}
				if (i === from / loadNum + itemsAfter) {
					pageslinks.push(
						`<li class="page-item"><a class="page-link news__page__links  news__page__last" href="#" data-from="${pages - 1
						}" ><span class="material-icons-outlined notranslate">last_page</span></a></li>`,
					);
				}
			} else {
				if (i === from / loadNum - itemsBefore) {
					pageslinks.push(
						'<li class="page-item"><a class="page-link news__page__links" href="#" data-from="0" >1</a></li><li class="page-item disabled"><a class="page-link news__page__links" href="#">...</a></li>',
					);
				}
				if ((i <= from / loadNum && i > from / loadNum - itemsBefore) || (i >= from / loadNum && i < from / loadNum + itemsAfter)) {
					pageslinks.push(
						`<li class="page-item ${i * loadNum === from ? "disabled" : ""}"><a class="page-link news__page__links " href="#" data-from="${i * loadNum}" >${i + 1}</a></li>`,
					);
				}
				if (i === from / loadNum + itemsAfter) {
					pageslinks.push(
						`<li class="page-item disabled"><a class="page-link news__page__links" href="#">...</a></li><li class="page-item"><a class="page-link news__page__links " href="#" data-from="${(pages - 1) * loadNum
						}" >${pages}</a></li>`,
					);
				}
			}
		} else {
			pageslinks.push(
				`<li class="page-item ${i * loadNum === from ? "disabled" : ""}"><a class="page-link news__page__links " href="#" data-from="${i * loadNum}" >${i + 1}</a></li>`,
			);
		}
	}

	pageslinks = pageslinks.join("");
	return pageslinks;
};
